import { getKnownTagIds, getTag } from '../../shared/tags/tagDictionary';

export default function TagChips({ tags, className = '' }) {
  const ids = getKnownTagIds(tags);
  if (!ids.length) return null;

  return (
    <div className={`gs-tag-chips ${className}`.trim()} aria-label="Tags">
      {ids.map((id) => {
        const def = getTag(id);
        if (!def) return null;
        return (
          <span
            key={id}
            className="gs-tag-chip"
          >
            {def.en}
          </span>
        );
      })}
    </div>
  );
}
